import React, { useState } from 'react';
import { Globe, Rotate3d, CalendarDays, MessageCircle } from 'lucide-react';
import VisorWeb from '../recorrido360/VisorWeb';
import SinServicio from '../recorrido360/SinServicio';
import useWebs from './useWebs';
import useRecorridos360 from '../recorrido360/useRecorridos360';
import { PRECIO_WEB, EJEMPLO_WEB, linkPedirWeb } from '../recorrido360/recorrido360.config';

/* Pestaña "Página web" (macro sección propia, al lado de Recorrido 360°). Las webs CON 360 de la Insta360 van en
   Recorrido 360°; acá van las otras. Mismo esquema: si la cámara ya tiene web, se ve adentro (con solapas si hay varias:
   la de la obra, la de la empresa); si no, qué es, el precio, la web de ejemplo (Esquina Gaona) y el pedido por el
   WhatsApp de ventas. El formulario viejo (PaginaWeb.jsx) quedó sin uso en el menú. */

const ETIQUETA = { obra: 'Web de la obra', empresa: 'Web de la empresa', bot: 'Reporte web' };
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const fecha = (iso) => { const [a, m, d] = (iso || '').split('-').map(Number); return d ? `${d} ${MESES[m - 1]} ${a}` : ''; };

const BotonWhatsApp = ({ href, children, chico }) => (
  <a href={href} target="_blank" rel="noopener noreferrer"
    className={`inline-flex items-center justify-center gap-2 rounded-xl font-semibold text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 shadow-sm ${chico ? 'px-4 py-2 text-sm' : 'px-6 py-3 text-base'}`}>
    <MessageCircle size={chico ? 16 : 20} />{children}
  </a>
);

export default function PaginaWebTab({ user = {}, customerInfo, onIrA }) {
  const webs = useWebs(user.feedID, user.identifier);
  const con360 = useRecorridos360({ feedID: user.feedID, identifier: user.identifier });
  const [sel, setSel] = useState(0);
  const datos = { obra: user.Name, empresa: customerInfo?.name, feedID: user.feedID };

  const aviso360 = con360 && (
    <div className="bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 text-sm text-blue-900 flex flex-wrap items-center justify-between gap-3">
      <span className="inline-flex items-center gap-2"><Rotate3d size={16} />Tu web con el recorrido 360° de la obra está en la pestaña <b>Recorrido 360°</b>.</span>
      {onIrA && <button type="button" onClick={() => onIrA('Recorrido 360°')} className="px-4 py-2 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700">Ver el recorrido 360°</button>}
    </div>
  );

  if (!webs) {
    return (
      <div className="space-y-5">
        <SinServicio
          Icono={Globe} etiqueta="Página web" tipo="web"
          titulo="Esta obra todavía no tiene página web"
          texto="Una web para mostrar el proyecto a compradores e inversores, con lo que ya registra tu cámara Lisual. La armamos nosotros con tu material."
          contratarTexto="Contratar página web" contratarHref={linkPedirWeb(datos)}
          precio={PRECIO_WEB} detallePrecio="Diseño y armado de la web de tu obra"
          ejemploUrl={EJEMPLO_WEB} ejemploNombre="Esquina Gaona, ABS Estudio"
          beneficios={['La obra en vivo y el avance día a día', 'Mapa 3D con la ubicación', 'Renders, planos y brochure', 'Tu dominio y tu marca']}
        />
        {aviso360}
      </div>
    );
  }


  const web = webs[sel] || webs[0];
  return (
    <div className="space-y-5">
      <div className="bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 text-sm text-blue-900 flex flex-wrap items-center justify-between gap-3">
        <span>¿Querés cambios en tu web o una web nueva para otra obra? <b>{PRECIO_WEB}</b> por web.</span>
        <BotonWhatsApp href={linkPedirWeb({ ...datos, cambios: true })} chico>Hablar con ventas</BotonWhatsApp>
      </div>

      <div>
        <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full"><Globe size={13} />Página web</div>
        <h2 className="mt-2 text-2xl md:text-3xl font-bold text-gray-800 leading-tight">{web.titulo}</h2>
        <p className="text-gray-600 text-sm mt-1 inline-flex items-center gap-1.5"><CalendarDays size={14} />Actualizada el {fecha(web.actualizada)} · compartila con compradores e inversores.</p>
      </div>

      {webs.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {webs.map((w, i) => (
            <button key={w.url} type="button" onClick={() => setSel(i)}
              className={`px-4 py-2 rounded-full text-sm font-medium border whitespace-nowrap ${i === sel ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'}`}>
              {ETIQUETA[w.tipo] || 'Web'}{webs.filter((x) => x.tipo === w.tipo).length > 1 ? ` · ${w.titulo.split('·').pop().trim()}` : ''}
            </button>
          ))}
        </div>
      )}

      <VisorWeb key={web.url} url={web.url} titulo={web.titulo} tipo="web" />
      {aviso360}
    </div>
  );
}
